import { Suspense, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ClearfieldHero from './components/ClearfieldHero';
import ClearfieldTrust from './components/ClearfieldTrust';
import ClearfieldServices from './components/ClearfieldServices';
import ClearfieldNeighborhoods from './components/ClearfieldNeighborhoods';
import ClearfieldTestimonial from './components/ClearfieldTestimonial';
import ClearfieldContact from './components/ClearfieldContact';

export default function ClearfieldPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Clearfield Utah | 24/7 Emergency Flood Cleanup Services';
    
    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Clearfield, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair near Hill Air Force Base. Fast response, certified professionals. Call (385) 340-6632 for immediate assistance.' },
      { name: 'keywords', content: 'water damage restoration Clearfield, flood cleanup Clearfield Utah, emergency water removal Clearfield, mold remediation Clearfield, fire damage repair Clearfield' },
      { name: 'geo.position', content: '41.1108;-112.0261' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Clearfield, Utah' },
      { property: 'og:title', content: 'Water Damage Restoration Clearfield Utah | Davis County Disaster Cleanup' },
      { property: 'og:description', content: '24/7 emergency water damage restoration in Clearfield. Expert flood cleanup, mold removal, and disaster recovery services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/clearfield' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Clearfield Utah | Davis County Disaster Cleanup' },
      { name: 'twitter:description', content: '24/7 emergency water damage restoration in Clearfield. Expert flood cleanup and disaster recovery.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/clearfield');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency water damage restoration in Clearfield?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Davis County Disaster Cleanup provides 24/7 emergency water damage restoration services throughout Clearfield, Utah. We respond immediately to water emergencies near Hill Air Force Base, Clearfield Station, and all Clearfield neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to water damage in Clearfield?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive within 60 minutes for emergency water damage calls in Clearfield. Our local team knows the area well, from Hill Field Road to the Clearfield Aquatic Center, ensuring rapid response times."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Clearfield do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Clearfield including Hill Air Force Base area, Clearfield Station, East Clearfield, West Clearfield, Steed Creek neighborhoods, and South Clearfield. No location in Clearfield is too far for our emergency response team."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="clearfield-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'clearfield-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="clearfield-faq"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <ClearfieldHero />
        <ClearfieldTrust />
        <ClearfieldServices />
        <ClearfieldNeighborhoods />
        <ClearfieldTestimonial />
        <ClearfieldContact />
        <Footer />
      </div>
    </Suspense>
  );
}
